type Config = {
    sentry: {
        dsn: string
    }
}

export const config: Config = {
    sentry: {
        dsn: "", // Sentry disabled (no external resources)
    },
}
